import { Props } from 'shared/@types';
import { PurchaseTermsScreen } from 'shared/screens/purchase-terms';
import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';

export default function PurchaseTerms(props: Props) {
  const { t } = useTranslation('web');

  return (
    <Page {...props} register={(seo) => seo.setTitle(t('layout.footer.purchase_terms'))}>
      <PurchaseTermsScreen />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
